import { SVG, SVGProps } from './svg'

export function IconToolPolygon(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M17.9 6.6a2 2 0 10-3.8.1l-6.8 4.8A2 2 0 106 15l2 7.3a2 2 0 102.9 2.4l8.1.6a2 2 0 103.3-1.8l4.3-8.5a2 2 0 002.4-2 2 2 0 00-3.4-1.5L18 6.6zm-.5.9a2 2 0 01-2.7 0l-6.8 4.8a2 2 0 01-1 2.4L9 22H9c1 0 1.8.7 2 1.7l8.1.6a2 2 0 012.3-1.3l4.3-8.5a2 2 0 01-.6-2.1l-7.7-5zM16 7a1 1 0 100-2 1 1 0 000 2zm11 7a1 1 0 100-2 1 1 0 000 2zm-6 12a1 1 0 100-2 1 1 0 000 2zM9 25a1 1 0 100-2 1 1 0 000 2zM6 14a1 1 0 100-2 1 1 0 000 2z"
      />
    </SVG>
  )
}
